import { ref } from 'vue';
import { defineStore } from "pinia";
import { CompletedchecksService, ReportsService, type CompletedCheckDto } from '@/client';

export const useCompletedCheckStore = defineStore("completedcheck", () => {

    async function getCompletedCheck(id:number) {
        return await CompletedchecksService.getApiCompletedchecksById({id})
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((error:any) => {
            return Promise.reject(error);
        })
    }

    async function getCompletedChecksByDateRange(from:string, to:string) {
        return await CompletedchecksService.getApiCompletedchecksBydate({from, to})
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((error:any) => {
            return Promise.reject(error);
        })
    }

    async function addRetrospectiveCheck(completedCheck:CompletedCheckDto) {
        return await CompletedchecksService.postApiCompletedchecksSaveretroactive({requestBody: completedCheck})
        .then((response) => {
            return Promise.resolve(response);
        }).catch((error:any) => {
            return Promise.reject(error);
        });
    }

    async function getDailyReport(from: string, to: string, checkIds: string[] | null) {
        return await ReportsService.getApiReportsDailyCheckReport({from, to, checkIds})
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((error:any) => {
            console.log(error)
            return Promise.reject(error);
        })
    }


    return {
        getCompletedCheck,
        getCompletedChecksByDateRange,
        addRetrospectiveCheck,
        getDailyReport 
    };
});